import React from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import { siteConfig } from '../data/config';

const LegalPage = () => {
    return (
        <div className="app">
            <Header 
                name={siteConfig.humoristName} 
                tagline={siteConfig.tagline}
                height="20vh"
                centered={true}
            />
            <section className="legal-section">
                <div className="container">
                    <h1>Mentions Légales</h1>
                    
                    <div className="legal-content">
                        <h2>Éditeur du site</h2>
                        <p>Le site {window.location.hostname} est édité par :</p>
                        <p>Antoine Officieux</p>
                        <p>Email : {siteConfig.contactEmail}</p>
                        
                        <h2>Hébergement</h2>
                        <p>Ce site est hébergé par GitHub Pages, un service de GitHub, Inc.</p>
                        <p>GitHub, Inc.</p>
                        <p>88 Colin P Kelly Jr St, San Francisco, CA 94107, United States</p>
                        
                        <h2>Propriété intellectuelle</h2>
                        <p>L'ensemble du contenu de ce site (textes, images, vidéos) est la propriété exclusive d'Antoine Officieux ou de ses partenaires. Toute reproduction, même partielle, est interdite sans autorisation préalable.</p>
                        
                        <h2>Données personnelles</h2>
                        <p>Ce site ne collecte aucune donnée personnelle des visiteurs.</p>
                        
                        <h2>Cookies</h2>
                        <p>Ce site utilise des cookies à des fins statistiques et pour améliorer l'expérience utilisateur. Vous pouvez désactiver les cookies dans les paramètres de votre navigateur.</p>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    );
};

export default LegalPage;